"use client";

import { Archive, Bell, Cube, Files, MagicWand, Users } from "@phosphor-icons/react";

import { cn } from "@shared/ui/utils";

import { Section } from "../section";

const infos = [
  {
    Icon: Cube,
    label: "Nested structure",
    description: "Organize your infrastructure with workspaces and projects for better management and control",
    className: "bg-gradient-to-b",
    cardClassName: "group-hover:bg-linear-to-br",
  },
  {
    Icon: Bell,
    label: "Notifications",
    description: "Get instant job and deployment updates—our monitoring keeps you informed",
    className: "bg-gradient-to-b",
    cardClassName: "group-hover:bg-linear-to-b",
  },
  {
    Icon: Files,
    label: "Track events",
    description: "Tract actions and team activity effortlessly with detailed event logs and monitoring",
    className: "bg-gradient-to-b",
    cardClassName: "group-hover:bg-linear-to-bl",
  },
  {
    Icon: Users,
    label: "Team management",
    description: "Invite teammates and manage access levels seamlessly with customizable access levels",
    className: "bg-gradient-to-t",
    cardClassName: "group-hover:bg-linear-to-tr",
  },
  {
    Icon: Archive,
    label: "Container registry",
    description: "Streamline app building and deployment with easy container registry management",
    className: "bg-gradient-to-t",
    cardClassName: "group-hover:bg-linear-to-t",
  },
  {
    Icon: MagicWand,
    label: "Custom images",
    description: "Create custom runners packed with tools, dependencies, and configurations for your workflows",
    className: "bg-gradient-to-t",
    cardClassName: "group-hover:bg-linear-to-tl",
  },
];

export const FeaturesInfo = () => {
  return (
    <Section title="Tenki platform features" contentClass="md:grid-cols-1">
      <div className="grid w-full grid-cols-1 md:grid-cols-3">
        {infos.map((info, index) => {
          return (
            <div key={info.label} className={cn("group relative flex flex-col p-8")}>
              <div
                className={cn(
                  "absolute inset-x-0 h-[0.5px] border-white/20",
                  index < 3 && "bottom-0 border-b",
                  index > 3 && "top-0 border-t md:border-transparent",
                )}
              />
              <div
                className={cn(
                  "absolute inset-y-0 left-0 w-0 border-transparent from-transparent to-white/20 md:w-[0.5px]",
                  info.className,
                )}
              />
              <div
                className={cn(
                  "absolute inset-y-0 right-0 w-0 border-transparent from-transparent to-white/20 md:w-[0.5px]",
                  info.className,
                )}
              />
              <div className="bg-feature-card-icon flex size-12 items-center justify-center rounded-lg">
                <info.Icon className="h-5 w-5" weight="fill" />
              </div>
              <div className="mt-4">
                <label className="text-lg">{info.label}</label>
                <p className="text-static-secondary text-md">{info.description}</p>
              </div>
              <div
                className={cn(
                  "absolute top-0 left-0 -z-10 h-full w-full from-[#000A15] to-[#001226] opacity-0 transition-all duration-700 group-hover:opacity-100",
                  info.cardClassName,
                )}
              />
            </div>
          );
        })}
      </div>
    </Section>
  );
};
